import {IResponse, requestBase, requestWithToken} from "./RequestBase";
import {config} from "../config";
import {actions, actions as actionsFile, IFile} from "../store/sliceFiles";
import {store} from "../store/configureStore";
import {actions as modal} from "../store/sliceModal";
import {uploadFile} from "./FileRequest";

export const fetchPublicFiles = async (publicId: string, id: number | null = null): Promise<IResponse> => {
    const request = id == null ? `${config.baseurl}/api/public/file/${publicId}` : `${config.baseurl}/api/public/file/${publicId}/${id}`
    const data: IResponse = await requestBase(request,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (data?.status == null) {
        store.dispatch(modal.showError("Ошибка запроса"))
    }
    // else if (data.status != 401 && data.status >= 400) {
    //     store.dispatch(modal.showError(data.data))
    // }

    if (data?.status === 200) {
        const files: IFile[] = data.data;
        store.dispatch(actionsFile.setFiles(files))
    }
    return data;
}

export const fetchPublicRotateIcon = async (publicId: string, id: number, rotate: number): Promise<IResponse> => {
    const url = `${config.baseurl}/api/public/file/${publicId}/rotate`
    const data: IResponse = await requestBase(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id, rotate})
        }
    );

    if (data?.status === 200) {
        const file: IFile = data.data;
        store.dispatch(actions.changeIconFile(file))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchPublicUploadFile = async (publicId: string, id: number, name?: string): Promise<IResponse> => {
    const data: IResponse = await requestBase(`${config.baseurl}/api/public/file/${publicId}/upload/${id}`,
        {
            method: "GET",
        },
        true
    );
    if (data.status === 200) {
        // Create blob link to download
        uploadFile(data, name)
    }
    if (data.isError) {
        store.dispatch(modal.showError("Ошибка выгрузки файла"))
    }

    return data;
}

export const fetchPublicUploadFiles = async (publicId: string, ids: number[]): Promise<IResponse> => {
    const params = ids.map((n)=> `ids=${n}`).join("&")
    const data: IResponse = await requestBase(`${config.baseurl}/api/public/file/${publicId}/upload?${params}`,
        {
            method: "GET",
        },
        true
    );

    if (data?.status === 200) {
        uploadFile(data)
    }
    return data;
}
